import { Component, inject } from '@angular/core';
import { SmartphotoService } from '../../../services/smartphoto.service';
import { MatDialog } from '@angular/material/dialog';
import { SmartphotoPicturesGalleryDialog } from './smartphoto-pictures-gallery/smartphoto-pictures-gallery-dialog.component';

@Component({
  selector: 'app-smartphoto-pictures',
  templateUrl: './smartphoto-pictures.component.html',
  styleUrl: './smartphoto-pictures.component.scss'
})
export class SmartphotoPicturesComponent {
  protected readonly smartphotoService = inject(SmartphotoService);
  private readonly dialog = inject(MatDialog);

  public images$ = this.smartphotoService.get.images();
  public statusDetails$ = this.smartphotoService.statusDetails$;

  public openGallery(index: number): void {
    this.dialog.open(SmartphotoPicturesGalleryDialog, {
      maxWidth: '100vw',
      maxHeight: '100vh',
      height: '100%',
      width: '100%',
      data: {
        initialSlide: index
      }
    });
  }
  public goToEvidenceCapture(): void {
    window.open(this.smartphotoService.getEvidenceCaptureLink(), '_self');
  }
}
